<template>
  <b-button-group class="mb-2">
    <b-button
      class="mr-2"
      size="sm"
      variant="outline-danger"
      @click="$emit('batchDel')"
    >
      <!-- <i class="el-icon-delete" /> -->
      {{ $l('INDEX.btn_delete') || '删除' }}
    </b-button>
  </b-button-group>
</template>
<script>
export default {}
</script>
